import { Dispatch, SetStateAction } from 'react'
import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { validateScan } from 'services/BankValidationService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { MappedErrorMessageState } from 'types/errors'
import { QueryMetaType } from 'types/reactQuery'

export const useScanValidation = (
  sortCode: string,
  accountNumber: string,
  setRequestError: Dispatch<SetStateAction<MappedErrorMessageState>>,
  enabled = false
) => {
  const meta: QueryMetaType = {
    excludedErrorCodes: [400],
    onErrorAdditional: (error: BaseErrorResponse) => {
      setRequestError({
        errorCode: error.status,
        show: true,
      })
    },
    errorAdditionalData: {
      sortCode,
      accountNumber,
    },
  }

  return useQuery({
    queryKey: reactQueryKeys.validateScan({ sortCode, accountNumber }),
    queryFn: () => validateScan({ sortCode, accountNumber }),
    enabled: enabled,
    gcTime: 0,
    meta,
  })
}
